import React from "react";
import { HeaderContainer, Page, PageHeader } from "components/ui/Page";
import { Link, Route, Routes } from "react-router-dom";
import { CardBody } from "components/ui/Card";
import Spinner from "components/ui/Spinner";
import { LargeSpacer, MediumSpacer } from "components/ui/VerticalSpacers";
import WithCurrentTeachingCourse from "components/data/WithCurrentTeachingCourse";
import CourseContext from "components/contexts/CourseContext";
import { SemesterLink } from "components/ui/SemesterLink";
import { RosterCard } from "components/cards/RosterCard";
import ClassInfoTab from "./TeachingCoursePage/ClassInfoTab";
import EnrollmentInfoTab from "./TeachingCoursePage/EnrollmentInfoTab";
import { TeachingButtonGroup } from "components/ui/TeachingButtonGroup";

export function TeachingCoursePage() {
  return (
    <Page>
      <WithCurrentTeachingCourse>
        <CourseContext.Consumer>
          {({ currentTeachingCourse, currentTeachingSemester, loadState }) => {
            if (loadState === "pending") {
              return (
                <CardBody>
                  <Spinner />
                </CardBody>
              );
            }

            if (currentTeachingCourse) {
              return (
                <>
                  <MediumSpacer />
                  <HeaderContainer>
                    <PageHeader style={{ paddingTop: `0` }}>
                      <Link to="/academics">My Academics</Link>
                      <> » </>
                      <SemesterLink />
                      <> » </>
                      <span style={{ textWrap: "nowrap" }}>
                        {currentTeachingCourse.course_code}
                      </span>
                    </PageHeader>

                    <TeachingButtonGroup />
                  </HeaderContainer>

                  <LargeSpacer />

                  <Routes>
                    <Route
                      index
                      path="/"
                      element={
                        <ClassInfoTab
                          currentCourse={currentTeachingCourse}
                          currentSemester={currentTeachingSemester}
                          loadState={loadState}
                        />
                      }
                    />

                    <Route
                      path="enrollment"
                      element={
                        <EnrollmentInfoTab
                          currentCourse={currentTeachingCourse}
                          currentSemester={currentTeachingSemester}
                        />
                      }
                    />

                    <Route
                      path="roster"
                      element={
                        <RosterCard
                          course={currentTeachingCourse}
                          semester={currentTeachingSemester}
                        />
                      }
                    />
                  </Routes>
                </>
              );
            }

            return null;
          }}
        </CourseContext.Consumer>
      </WithCurrentTeachingCourse>
    </Page>
  );
}
TeachingCoursePage.displayName = "TeachingCoursePage";
